import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './components/App'

export const startBillingQueue = initialData => {
  const root = createRoot(document.getElementById('billingQueueApp'))
  root.render(<App initialData={initialData} />)
}
